export const actionTypes = {
  REQUEST_START: 'TAPS.ACCOUNT_SIGN.REQUEST_START',
  REQUEST_SUCCESS: 'TAPS.ACCOUNT_SIGN.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'TAPS.ACCOUNT_SIGN.REQUEST_FAILURE',
};

export function startRequest() {
  return {
    type: actionTypes.REQUEST_START,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}
